import { render, staticRenderFns } from "./productAndPicklist.vue?vue&type=template&id=ef97bb7a&"
import script from "./productAndPicklist.vue?vue&type=script&lang=js&"
export * from "./productAndPicklist.vue?vue&type=script&lang=js&"
import style0 from "./productAndPicklist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports